export default "__VITE_ASSET__94692058__"